import script from "./tiptap-menu-button.vue?vue&type=script&setup=true&lang=js"
export * from "./tiptap-menu-button.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__